import React, { useEffect, useRef, useState } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import Select from "react-select";
import { optionMarkupType } from "../../../../common/data/common";
import { delete_icon } from "../../../../assets/images";
import {
    ADD_QUOTE_MODAL_CHARGES,
    REMOVE_QUOTE_MODAL_CHARGES,
    UPDATE_QUOTE_MODAL_CHARGES
} from "../../../../store/Sales/Quotation/actiontype";
import { QUOTATION_RESULT_UPDATE, SMART_QUOTATION_VALUE_UPDATE } from "../../../../store/InstantRate/actionType";
import { applyGrossMargin, convertCurrency } from "../../../../components/Common/CommonLogic";
import { useDispatch, useSelector } from "react-redux";
import { GET_SURCHARGE_CATEGORY_DATA, GET_SURCHARGE_CODE_DATA } from "../../../../store/Global/actiontype";
import { airSurChargesHeaderMap, surChargesHeaderMap } from "../../../Dashboard/Partials/initialData";
import AddNewSurchargeModal from "../../../Settings/Surcharge/Modal/AddNewSurchargeModal";


const AirCharges = ({ tabName, tariffDetails, isApplyingBids, validation, locationFrom }) => {
    const viewData = false;
    const dispatch = useDispatch();
    const mainChargeObj = useSelector((state) => state?.quotation?.mainChargeObj);
    const { activeQuotationsViewDetails } = useSelector((state) => state?.sales);
    const { cargoType_data, surchargeCode_data, UOM_data, currency_data, container_data } = useSelector((state) => state?.globalReducer);
    const { currency_ExchangeRate } = useSelector((state) => state.quotation);
    const { smartQuotationsValues } = useSelector((state) => state.instantRate);
    //const [validation, setValidation] = useState([]);
    const [openInner, setOpenInner] = useState('');
    const [multiOpenInner, setMultiOpenInner] = useState(['subacco_0', 'subacco_1', 'subacco_2', 'subacco_3', 'subacco_4', 'subacco_5']);
    const targetScrollRef = useRef(null);
    const inputFocusRef = useRef(null);
    const [addNewSurchargeModal, setAddNewSurchargeModal] = useState(false);
    const [surchargeDataCategory, setSurchargeDataCategory] = useState('');

    useEffect(() => {
        dispatch({ type: GET_SURCHARGE_CODE_DATA });
    }, []);

    const toggle2 = (id) => {
        if (openInner === id) {
            setOpenInner('');
        } else {
            setOpenInner(id);
        }
    };

    const applyingBidingToogle = (id) => {
        if (multiOpenInner.includes(id)) {
            setMultiOpenInner(multiOpenInner.filter(openId => openId !== id)); // collapse
        } else {
            setMultiOpenInner([...multiOpenInner, id]); // open
        }
    }

    useEffect(() => {
        if (isApplyingBids) {
            let id = 'quote_0';
            let charge_name = 'AIR_CHARGES';
            if (activeQuotationsViewDetails?.inquiryField?.containerDetails?.length > 0) {
                activeQuotationsViewDetails?.inquiryField?.containerDetails?.map((item, index) => {
                    dispatch({ type: ADD_QUOTE_MODAL_CHARGES, payload: { id, charge_name, value: true, name: 'isDefault' } })
                    dispatch({ type: UPDATE_QUOTE_MODAL_CHARGES, payload: { charge_name, id, value: container_data.find(data => String(data.id) === String(item.id)), name: 'component', index, sales_cost: 0, newVal: 0 } });
                    dispatch({ type: UPDATE_QUOTE_MODAL_CHARGES, payload: { charge_name, id, value: item.noOfUnits, name: 'unit', index, sales_cost: 0, newVal: 0 } })
                    dispatch({
                        type: UPDATE_QUOTE_MODAL_CHARGES, payload: {
                            charge_name, id, value: { label: 'PER CONTAINER', value: 'PER_CONTAINER', description: 'PER CONTAINER', id: 2, version: 0 },
                            name: 'uomCode', index, sales_cost: 0, newVal: 0
                        }
                    });
                    dispatch({ type: UPDATE_QUOTE_MODAL_CHARGES, payload: { charge_name, id, value: true, name: 'isDefault', index, sales_cost: 0, newVal: 0 } });
                    dispatch({ type: UPDATE_QUOTE_MODAL_CHARGES, payload: { charge_name, id, value: 2, name: 'inPosition', index, sales_cost: 0, newVal: 0 } });
                    dispatch({ type: UPDATE_QUOTE_MODAL_CHARGES, payload: { charge_name, id, value: "USD", name: "currencyCode", index, sales_cost: 0, newVal: 0 } });
                    let filterCurrency = currency_ExchangeRate?.find(data => data?.baseCurrency?.currencyCode === 'USD' && data?.targetCurrency?.currencyCode === smartQuotationsValues?.quote_currency?.currencyCode);
                    dispatch({ type: UPDATE_QUOTE_MODAL_CHARGES, payload: { charge_name, id, value: filterCurrency?.value, name: "roe_val", index, sales_cost: 0, newVal: 0 } });
                })
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        targetScrollRef.current?.scrollIntoView({ behavior: 'smooth' });
                        inputFocusRef.current?.focus({ preventScroll: true });
                    }, 200);
                });
            }
        }
    }, [activeQuotationsViewDetails]);

    const addHandler = (charge_name, id) => {
        //console.log(id, charge_name, "Check id, cj");
        dispatch({ type: ADD_QUOTE_MODAL_CHARGES, payload: { id, charge_name } })
    }

    const handleChange = (value, name, index, charge_name, objId, sales_cost, newVal) => {
        //console.log(value, name, index, charge_name, objId, sales_cost, newVal, "value, name, index, charge_name, objId, sales_cost, newVal");
        dispatch({ type: UPDATE_QUOTE_MODAL_CHARGES, payload: { charge_name, id: objId, value, name, index, sales_cost, newVal } })
    }

    const removeInputFields = (index, id, header) => {
        dispatch({ type: REMOVE_QUOTE_MODAL_CHARGES, payload: { index, id, header } })
    }

    const existingHandleChange = (value, name, subindex, charge_name, objId, index, sales_cost, marginVal) => {
        dispatch({ type: QUOTATION_RESULT_UPDATE, payload: { value, name, subindex, charge_name, id: objId, index, sales_cost, marginVal } })
    }

    const existingHandleChangeMargin = (data, value, name, subindex, charge_name, objId, index) => {
        let sale_cost = 0;
        let marginValue = 0;

        if (name === 'markup_val') {
            marginValue = calculateMarkupVal(data.markup_type, Number(data.amount), Number(value));
        } else if (name === "markup_type") {
            marginValue = calculateMarkupVal(value, Number(data.amount), data?.markup_val || 0);
        }

        sale_cost = Number(data.amount) + marginValue;
        sale_cost = Number(data.amount) + marginValue + (data?.taxDetail && data?.taxDetail?.value || 0);
        existingHandleChange(value, name, subindex, charge_name, objId, index, sale_cost, marginValue);
    }

    const calculateMarkupVal = (type, buycost, value) => {
        if (type === 'FLAT') {
            return value;
        } else {
            return (buycost * value / 100)
        }
    }
    const calculateTax = (buycost, value) => {
        return (buycost * value / 100)
    }

    const handleTotalBidAmountCalculate = (value, name, index, charge_name, objId, sales_cost, newVal) => {
        //console.log(newData, " NewData", value, " Value", name, " Name");
        dispatch({ type: UPDATE_QUOTE_MODAL_CHARGES, payload: { charge_name, id: objId, value, name, index, sales_cost, newVal } })
    }

    const handleChangeAndCalculate = (data, value, name, index, charge_name, objId) => {
        let sale_cost = 0;
        if (name === 'markup_val') {
            let totalAmt = Number(data.unitPerPrice) * Number(data.unit || 1);
            let marginValue = calculateMarkupVal(data.markup_type, totalAmt, Number(value));
            sale_cost = totalAmt + marginValue;
            sale_cost = totalAmt + marginValue + (data?.taxDetail?.taxPercentage ? calculateTax(totalAmt, Number(data?.taxDetail?.taxPercentage)) : 0);
            handleChange(value, name, index, charge_name, objId, sale_cost, marginValue);
        } else if (name === 'unitPerPrice') {
            let totalAmt = Number(value) * Number(data.unit || 1);
            let marginValue = calculateMarkupVal(data.markup_type, totalAmt, Number(data.markup_val));
            sale_cost = totalAmt + marginValue;
            sale_cost = totalAmt + marginValue + (data?.taxDetail?.taxPercentage ? calculateTax(totalAmt, Number(data?.taxDetail?.taxPercentage)) : 0);
            handleChange(value, name, index, charge_name, objId, sale_cost, marginValue);
        } else if (name === 'unit') {
            let totalAmt = Number(data.unitPerPrice || 0) * Number(value || 1);
            let marginValue = calculateMarkupVal(data.markup_type, totalAmt, Number(data.markup_val));;
            sale_cost = totalAmt + marginValue;
            sale_cost = totalAmt + marginValue + (data?.taxDetail?.taxPercentage ? calculateTax(totalAmt, Number(data?.taxDetail?.taxPercentage)) : 0);
            handleChange(value, name, index, charge_name, objId, sale_cost, marginValue);
        }
    }

    const innerTotalHandler = (array, newArray) => {
        if (!isApplyingBids) {
            let amt = array?.reduce((total, charge) =>
                total + convertCurrency(charge, charge?.total_sale_cost, currency_ExchangeRate, smartQuotationsValues), 0)
                + (newArray !== undefined ? newArray?.reduce((total, charge) => total + convertCurrency(charge, Number(charge?.total_sale_cost), currency_ExchangeRate, smartQuotationsValues), 0) : 0)
            return amt;
        } else {
            let amt = array?.reduce((total, charge) =>
                total + convertCurrency(charge, charge?.sales_cost, currency_ExchangeRate, smartQuotationsValues), 0)
                + (newArray !== undefined ? newArray?.reduce((total, charge) => total + convertCurrency(charge, Number(charge?.sales_cost || charge?.total_sale_cost), currency_ExchangeRate, smartQuotationsValues), 0) : 0)
            return amt;
        }
    }

    const allTotalCostHandler = (quoteObject) => {
        const totalSum = quoteObject[0]?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = 0;
            innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                return accInner + convertCurrency(currentInner, Number(currentInner.sales_cost || currentInner.total_sale_cost), currency_ExchangeRate, smartQuotationsValues);
            }, 0);
            return accOuter + innerSum;
        }, 0);
        return Number.isNaN(totalSum) ? 0 : totalSum;
    }

    const subTotalHandler = (quoteObject) => {
        let mainChargeCurr = mainChargeObj?.find(obj => obj.id === item.quote_id) || [];
        //console.log(quoteObject, "quoteObject");
        const totalSum = quoteObject[0]?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = 0;
            innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                return accInner + convertCurrency(currentInner, Number(currentInner.total_sale_cost), currency_ExchangeRate, smartQuotationsValues);
            }, 0);
            return accOuter + innerSum;
        }, 0);

        // const totalMarginSum = quoteObject[0]?.tariffDetails?.reduce((accOuter, currentOuter) => {
        //     let innerSum = 0;
        //     innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
        //         return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, smartQuotationsValues);
        //     }, 0);
        //     return accOuter + innerSum;
        // }, 0);
        //
        // const newSubTotal = mainChargeCurr?.tariffDetails !== undefined ? mainChargeCurr?.tariffDetails?.reduce((accOuter, currentOuter) => {
        //     let innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
        //         let totalAmt = Number(currentInner.unitPerPrice || 0) * Number(currentInner.unit || 1);
        //         return accInner + convertCurrency(currentInner, Number(totalAmt), currency_ExchangeRate, smartQuotationsValues);;
        //     }, 0);
        //     return accOuter + innerSum;
        // }, 0) : 0;
        //
        // const totalNewMarginSum = mainChargeCurr?.tariffDetails !== undefined ? mainChargeCurr?.tariffDetails?.reduce((accOuter, currentOuter) => {
        //     let innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
        //         return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, smartQuotationsValues);
        //     }, 0);
        //     return accOuter + innerSum;
        // }, 0) : 0;

        let mainTotal = totalSum + 0 + 0 + 0;
        return Number.isNaN(mainTotal) ? 0 : mainTotal;
    }

    const overAllMarginHandler = (quoteObject, subtotalvalue) => {
        let mainChargeCurr = mainChargeObj?.find(obj => obj.id === quoteObject.quote_id) || [];

        const totalMarginSum = quoteObject?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = 0;
            if (currentOuter?.selected) {
                innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                    return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, searchForm);
                }, 0);
            }
            return accOuter + innerSum;
        }, 0);

        const totalNewMarginSum = mainChargeCurr?.tariffDetails !== undefined ? mainChargeCurr?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, searchForm);
            }, 0);
            return accOuter + innerSum;
        }, 0) : 0;


        let totalMargin = totalMarginSum + totalNewMarginSum;
        let buyvalue = subtotalvalue - totalMargin

        return (totalMargin * 100 / buyvalue).toFixed(2)
    }
    const item = {
        quote_id: "quote_0"
    }

    useEffect(() => {
        //console.log("smartQuotationsValues?.quote_currency", smartQuotationsValues?.quote_currency);
        mainChargeObj?.[0]?.tariffDetails.map((tariffs, index) => {
            tariffs.fclTariffBreakDowns.map((breakDown, breakDownIndex) => {
                if (breakDown.currencyCode !== '') {
                    let filterCurrency = currency_ExchangeRate?.find(data => data?.baseCurrency?.currencyCode === breakDown?.currencyCode && data?.targetCurrency?.currencyCode === smartQuotationsValues?.quote_currency?.currencyCode);
                    handleChange(filterCurrency?.value, 'roe_val', breakDownIndex, `${tariffs?.header}`, mainChargeObj?.[0]?.id);
                }
            });
        });
    }, [smartQuotationsValues?.quote_currency]);

    const filterSurChargeData =
        tabName === 'FCL'
            ? surchargeCode_data?.filter(data => data.transportMode === "OCEAN")
            : tabName === 'intl_Air'
                ? surchargeCode_data?.filter(data => data.transportMode === "AIR")
                : [];

    const filteredOptions =
        tabName === 'intl_Air'
            ? UOM_data?.filter(data => data.transportMode === "AIR")
            : tabName === 'FCL'
                ? UOM_data?.filter(data => data.transportMode === "OCEAN")
                : [];

    const surchargeDataFilter = (headerName) => {
        if (tabName === 'intl_Air') {
            return surchargeCode_data?.filter(data => data.transportMode === "AIR" && data?.surchargeCategory?.name === airSurChargesHeaderMap[headerName]);
        } else {
            const surchargeCodeList = surchargeCode_data?.filter(data => data.transportMode === "OCEAN" && data?.surchargeCategory?.name === surChargesHeaderMap[headerName]);
            return [
                ...surchargeCodeList,
                {
                    label: 'Add New Surcharge',
                    value: 'add_new_surcharge',
                }
            ];
        }
    }

    const handleOnAddNewSurchargeClose = () => {
        setAddNewSurchargeModal(false);
        dispatch({ type: GET_SURCHARGE_CODE_DATA });
    }

    return (
        <>
            <Accordion flush open={isApplyingBids ? multiOpenInner : multiOpenInner} toggle={isApplyingBids ? applyingBidingToogle : applyingBidingToogle}>
                {tariffDetails?.length !== 0 && tariffDetails?.map((data, index) => {
                    return (
                        <AccordionItem innerRef={data?.header === 'AIR_CHARGES' ? targetScrollRef : null} key={`${index}_${item.quote_id}`}>
                            <AccordionHeader targetId={`subacco_${index}`}>
                                {data?.header?.split('_').join(" ") || '-'}
                                <div className="right_con ms-auto">
                                    {/* <span className="price text-primary">{'₹'} {innerTotalHandler((item?.pickup_quote_charge || []), (mainChargeObj?.find(obj => obj.quote_id === item.quote_id)?.pickup_quote_charge || []))}</span> */}
                                    <span className="price text-primary">{smartQuotationsValues?.quote_currency?.label} {innerTotalHandler((data?.fclTariffBreakDowns || []), (mainChargeObj?.find(obj => obj.id === item.quote_id)?.tariffDetails?.find(obj => obj.header === data?.header)?.fclTariffBreakDowns || []))}</span>
                                </div>
                            </AccordionHeader>
                            <AccordionBody accordionId={`subacco_${index}`}>
                                {mainChargeObj?.find(obj => obj.id === item.quote_id)?.tariffDetails?.find(obj => obj.header === data?.header)?.fclTariffBreakDowns?.map((newdata, i) => (
                                    <div className="charges_wrap mt-3" key={i}>
                                        <div className="label_delete_wwrap d-flex justify-content-between">
                                            <label className="form-label">Select Charge</label>
                                            <div className="btn_wrap">
                                                {data?.header === "AIR_CHARGES" && newdata?.isDefault === true ? null : (
                                                    <button type='button' onClick={() => { removeInputFields(i, item.quote_id, `${data?.header}`) }} className="btn p-0"><img src={delete_icon} alt="Delete" /></button>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row align-items-center g-2">
                                            <div className={`col-${isApplyingBids ? '2' : '2'}`}>
                                                <div className="field_wrap">
                                                    {data?.header === "AIR_CHARGES" && newdata?.isDefault === true ? (
                                                        <input
                                                            type="text"
                                                            name="component"
                                                            id="component"
                                                            value={newdata?.component?.label || '0'}
                                                            onChange={(e) =>
                                                                handleChange(e.target.value, 'unit', i, data?.header, item.quote_id)
                                                            }
                                                            placeholder=""
                                                            readOnly
                                                        />
                                                    ) : (
                                                        <Select
                                                            value={newdata?.component ?? ''}
                                                            name="component"
                                                            onChange={(opt) => {
                                                                if(opt?.value === 'add_new_surcharge') {
                                                                    if(data?.header === 'ORIGIN_INLAND_CHARGES' || data?.header === 'DESTINATION_INLAND_CHARGES') {
                                                                        setSurchargeDataCategory("INLAND");
                                                                    } else if(data?.header === 'ORIGIN_LOCAL_PORT_CHARGES' || data?.header === 'DESTINATION_LOCAL_PORT_CHARGES') {
                                                                        setSurchargeDataCategory("PORT_LOCAL_CHRG");
                                                                    } else {
                                                                        setSurchargeDataCategory('OCEAN_CHARGE');
                                                                    }
                                                                    setAddNewSurchargeModal(true);
                                                                } else {
                                                                    handleChange(opt, 'component', i, data?.header, item.quote_id)
                                                                }
                                                            }}
                                                            options={surchargeDataFilter(data?.header)}
                                                            menuPlacement="auto"
                                                            classNamePrefix="form-select"
                                                            styles={{
                                                                control: (base, state) => ({
                                                                    ...base,
                                                                    borderColor: validation?.[data?.header]?.[i]?.error?.chargename ? 'red' : 'grey',
                                                                }),
                                                            }}
                                                        />
                                                    )}

                                                </div>
                                            </div>
                                            <div className={`col-${isApplyingBids ? '2' : '2'}`}>
                                                <div className="field_wrap">
                                                    <label className="form-label" style={{ position: "absolute", top: '-24px' }}>Charge Basis</label>
                                                    {data?.header === "FREIGHT_CHARGES" && newdata?.isDefault === true ? (
                                                        <input
                                                            type="text"
                                                            name="uomCode"
                                                            id="uomCode"
                                                            value={newdata?.uomCode?.label || '0'}
                                                            onChange={(e) =>
                                                                handleChange(e.target.value, 'unit', i, data?.header, item.quote_id)
                                                            }
                                                            placeholder=""
                                                            readOnly
                                                        />
                                                    ) : (
                                                        <Select
                                                            value={newdata?.uomCode || ''}
                                                            name='uomCode'
                                                            onChange={(opt) => {
                                                                handleChange(opt, 'uomCode', i, `${data?.header}`, item.quote_id);
                                                            }}

                                                            options={filteredOptions}
                                                            placeholder='Select'
                                                            classNamePrefix="form-select"
                                                            menuPlacement="auto"
                                                            styles={{
                                                                control: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    borderColor: !validation?.[data?.header]?.[i]?.error?.uomCode ? 'grey' : 'red',
                                                                }),
                                                            }}
                                                        />
                                                    )}

                                                </div>
                                            </div>
                                            <div className={`col-${isApplyingBids ? '1' : '1'}`}>
                                                <div className="field_wrap">
                                                    <label className="form-label" style={{ position: "absolute", top: '-24px' }}>Quantity</label>
                                                    <input
                                                        type="number"
                                                        min={0}
                                                        max={1000}
                                                        name="unit"
                                                        id="unit"
                                                        className={!validation?.[data?.header]?.[i]?.error?.unit ? '' : 'error'}
                                                        value={newdata?.unit || ''}
                                                        onChange={(e) => {
                                                            handleChangeAndCalculate(newdata, e.target.value, 'unit', i, `${data?.header}`, item.quote_id);
                                                            //handleChange(e.target.value, 'unit', i, `${data?.header}`, item.quote_id);
                                                        }}
                                                        placeholder='Enter quantity'
                                                        readOnly={data?.header === "FREIGHT_CHARGES" && newdata?.isDefault === true}
                                                    />
                                                </div>
                                            </div>
                                            <div className={`col-${isApplyingBids ? '2' : '2'}`}>
                                                <div className="field_wrap">
                                                    <label className="form-label" style={{ position: "absolute", top: '-24px' }}>Currency</label>
                                                    <Select
                                                        value={
                                                            currency_data
                                                                ? currency_data.find(
                                                                    obj =>
                                                                        obj.value === newdata?.currencyCode ||
                                                                        obj.currencyCode === newdata?.currencyCode
                                                                )
                                                                : ''
                                                        }
                                                        name='currencyCode'
                                                        onChange={(opt) => {
                                                            handleChange(opt?.currencyCode, 'currencyCode', i, `${data?.header}`, item.quote_id);
                                                            let filterCurrency = currency_ExchangeRate?.find(data => data?.baseCurrency?.currencyCode === opt?.currencyCode && data?.targetCurrency?.currencyCode === smartQuotationsValues?.quote_currency?.currencyCode);
                                                            handleChange(filterCurrency?.value, 'roe_val', i, `${data?.header}`, item.quote_id)
                                                        }}
                                                        options={currency_data}
                                                        classNamePrefix="form-select"
                                                        menuPlacement="auto"
                                                        styles={{
                                                            control: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                borderColor: !validation?.[data?.header]?.[i]?.error?.currencyCode ? 'grey' : 'red',
                                                            }),
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            {isApplyingBids && (
                                                <div className="col-1">
                                                    <div className="field_wrap">
                                                        <label className="form-label" style={{ position: "absolute", top: '-24px' }}>Unit Price</label>
                                                        <input type="number"
                                                            min={0}
                                                            max={1000000}
                                                            className={!validation?.[data?.header]?.[i]?.error?.unitPerPrice ? '' : 'error'}
                                                            name="unitPerPrice" id="unitPerPrice" value={newdata?.unitPerPrice || ''}
                                                            onChange={(e) => {
                                                                handleChangeAndCalculate(newdata, e.target.value, 'unitPerPrice', i, `${data?.header}`, item.quote_id);
                                                                //handleChange(e.target.value, 'unitPerPrice', i, `${data?.header}`, item.quote_id)
                                                            }} placeholder='Enter cost' />
                                                    </div>
                                                </div>
                                            )}
                                            {/* {!isApplyingBids && (
                                                <div className="col-2">
                                                    <div className="field_wrap">
                                                        <label className="form-label" style={{ position: "absolute", top: '-24px' }}>Markup Type</label>
                                                        <Select
                                                            value={optionMarkupType && optionMarkupType.find(obj => obj.value === newdata?.markup_type) || { label: "Percentage", value: "PERCENTAGE" }}
                                                            name='markup_type'
                                                            onChange={(opt) => {
                                                                handleChange(opt?.value, 'markup_type', i, `${data?.header}`, item.quote_id);
                                                            }}
                                                            options={optionMarkupType}
                                                            classNamePrefix="select2-selection form-select"
                                                            menuPlacement="auto"
                                                        />
                                                    </div>
                                                </div>
                                            )} */}
                                            {/* {!isApplyingBids && (
                                                <div className="col-1">
                                                    <div className="field_wrap">
                                                        <label className="form-label" style={{ position: "absolute", top: '-24px' }}>Markup Value</label>
                                                        <input type="number" min={0} max={1000000} name={`markup_val`} id="markup_val"
                                                            className={!validation?.[data?.header]?.[i]?.error?.markup_val ? '' : 'error'}
                                                            value={newdata?.markup_val || ''}
                                                            onChange={(e) => {
                                                                handleChangeAndCalculate(newdata, e.target.value, 'markup_val', i, `${data?.header}`, item.quote_id);
                                                            }}
                                                            placeholder='Enter value' />
                                                    </div>
                                                </div>
                                            )} */}
                                            <div className="col-1">
                                                <div className="field_wrap">
                                                    <label className="form-label" style={{ position: "absolute", top: '-24px' }}>Total Amount</label>
                                                    <input type="text"
                                                        ref={i === 0 ? inputFocusRef : null}
                                                        name="total_sale_cost"
                                                        id="total_sale_cost"
                                                        className={!validation?.[data?.header]?.[i]?.error?.total_sale_cost ? '' : 'error'}
                                                        value={newdata?.total_sale_cost || newdata?.sales_cost || ''}
                                                        placeholder='Enter cost'
                                                        onChange={(e) => {
                                                            handleTotalBidAmountCalculate(e.target.value, 'sales_cost', i, `${data?.header}`, item.quote_id);
                                                        }}
                                                        readOnly={isApplyingBids}
                                                        disabled={isApplyingBids}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-1">
                                                <div className="field_wrap">
                                                    <label className="form-label" style={{ position: "absolute", top: '-24px' }}>ROE</label>
                                                    <input type="number" min={0} max={1000000} name={`roe_val`} id="roe_val"
                                                        className={!validation?.[data?.header]?.[i]?.error?.roe_val ? '' : 'error'}
                                                        value={newdata?.roe_val || ''}
                                                        readOnly={true}
                                                        onChange={(e) => {
                                                            handleChange(e.target.value, 'roe_val', i, `${data?.header}`, item.quote_id)
                                                        }}
                                                        placeholder='Enter value' />
                                                </div>
                                            </div>

                                            <div className="col-2">
                                                <div className="field_wrap">
                                                    <label className="form-label" style={{ position: "absolute", top: '-24px' }}>Amount in {smartQuotationsValues?.quote_currency?.label}</label>
                                                    <input type="number" min={0} max={1000000} name={`amountincurrency`} id="amountincurrency"
                                                        className={!validation?.[data?.header]?.[i]?.error?.amountincurrency ? '' : 'error'}
                                                        value={convertCurrency(newdata, Number(newdata?.total_sale_cost || newdata?.sales_cost || 0), currency_ExchangeRate, smartQuotationsValues)}
                                                        onChange={(e) => {
                                                            handleChange(e.target.value, 'amountincurrency', i, `${data?.header}`, item.quote_id)
                                                        }}
                                                        readOnly={true}
                                                        placeholder='Enter value' />
                                                </div>
                                            </div>

                                            {/* <div className="col-1">
                                                                                <div className="field_wrap">
                                                                                    <input type="text" name="taxPercentage" id="taxPercentage"
                                                                                        value={newdata?.taxDetail?.taxPercentage || ''}
                                                                                        onChange={(e) => {
                                                                                            handleChangeAndCalculate(newdata, e, 'taxPercentage', i, `${data?.header}`, item.quote_id);
                                                                                        }}
                                                                                        placeholder='Enter tax'
                                                                                    />
                                                                                </div>
                                                                            </div> */}

                                        </div>
                                    </div>
                                ))}

                                {!viewData && (
                                    <div className="add_btn_box mt-3">
                                        <div className="add_btn_wrap">
                                            <button type='button' className="btn btn-primary add_btn d-flex align-items-center" onClick={() => { addHandler(`${data?.header}`, item?.quote_id); }}> <i className='bx bx-plus me-2'></i> Add Charges</button>
                                        </div>
                                    </div>
                                )}
                            </AccordionBody>
                        </AccordionItem>
                    )
                })}
            </Accordion>

            <div className="row justify-content-end">
                <div className="col-4 col-md-3 d-flex justify-content-between">
                    <span>Total Amount:</span>
                    <span>
                        <b className='h5'>
                            {/* {optionCurrency ? optionCurrency.find(obj => obj.value === formik.values.currencyVal).code + ' ' : '₹ '} */}
                            {/* {formik.values.currencyVal !== 'rupee' ? ((subTotalHandler(item) + totalTaxHandler(item)) * Number(formik.values.exchangeRate)).toFixed(2) : (subTotalHandler(item) + totalTaxHandler(item))} */}
                            {/* {(subTotalHandler(item) + totalTaxHandler(item))} */}
                            {smartQuotationsValues?.quote_currency?.currencyCode} {isApplyingBids ? allTotalCostHandler(mainChargeObj) || 0 : subTotalHandler(mainChargeObj)}
                        </b>
                    </span>
                </div>
            </div>
            <AddNewSurchargeModal modal={addNewSurchargeModal} onCloseClick={handleOnAddNewSurchargeClose} surchargeDataCategory={surchargeDataCategory} tabName={tabName} />
        </>
    );
}

export default AirCharges;
